<div class="wrap">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Non</button>
      <button mat-button color="primary" (click)="onYesClick()">Oui</button>
    </div>
</div>

